import { fetchAllEntries } from './fetchAllEntries';
import { call } from 'redux-saga/effects';

export function* reFetchAllEntries() {
  yield call(fetchAllEntries);
}
